import MapHandler from '../mapHandler';

import 'leaflet-ruler/src/leaflet-ruler.js';
import 'leaflet-ruler/src/leaflet-ruler.css';

export default class DebugActivity extends MapHandler {
  constructor(options = {}) {
    super(options);

    this.segmentLayers = [];
    this.segmentType = options.segmentType;
    this.addDebugMarkersToMap = this.addDebugMarkersToMap.bind(this);
    this._activitySamples = null;
    this._highlightMarker = null;

    L.control
      .ruler({
        position: 'topright',
        lengthUnit: {
          factor: 1000, // from km to m
          display: 'meters',
          decimal: 2,
        },
      })
      .addTo(this.map);
  }

  // this.drawPolyline(this.coordinates, false, {
  //   color: "#2C3232",
  //   opacity: this.selectControlEnabled ? .6 : 1,
  //   weight: 1
  // });

  /**
   * =========================================================
   * Debug
   */
  highlightSample(index) {
    this.clearHighlight();
    if (!this._activitySamples || !this._activitySamples[index]) return;
    const sample = this._activitySamples[index];
    if (sample.lat == null || sample.lng == null) return;
    this._highlightMarker = L.circleMarker(L.latLng(sample.lat, sample.lng), {
      color: '#ff6600',
      fillColor: '#ff6600',
      fillOpacity: 1,
      radius: 7,
      weight: 2,
    }).addTo(this.map);
  }

  clearHighlight() {
    if (this._highlightMarker) {
      this._highlightMarker.remove();
      this._highlightMarker = null;
    }
  }

  addDebugMarkersToMap(samples, type = 'activity', details) {
    if (type === 'activity') {
      this._activitySamples = samples;
    }

    // Add new segments
    samples.forEach(async (sample, index) => {
      const markerPopup = L.popup().setContent(
        type === 'activity'
          ? `${details ? `${details}</br>` : ''}time_in_seconds: ${
              sample.time_in_seconds
            }<br /> elapsed_time: ${sample.elapsed_time}<br /> lat: ${
              sample.lat
            }<br /> timer_time: ${sample.timer_time}<br /> lat: ${
              sample.lat
            }<br /> lng: ${sample.lng}<br /> altitude: ${
              sample.altitude
            }<br /> speed: ${sample.speed}<br /> power: ${
              sample.power
            }<br /> distance_in_meters: ${sample.distance_in_meters}
            <br /> manual: ${sample.manual}<br /> heart_rate: ${
              sample.heart_rate
            }`
          : `${details ? `${details}</br>` : ''}lat: ${sample.lat}<br /> lng: ${
              sample.lng
            }<br /> altitude: ${sample.altitude}<br />index: ${index}`
      );

      const marker = this.addMarker(
        L.latLng(sample.lat, sample.lng),
        {
          color:
            type === 'activity'
              ? sample.manual
                ? '#00ff33'
                : '#3388ff'
              : '#ff0000',
        },
        markerPopup
      );

      if (type === 'activity') {
        marker.on('mouseover', () => {
          if (this.onHoverSample) this.onHoverSample(index);
        });
        marker.on('mouseout', () => {
          if (this.onHoverSample) this.onHoverSample(null);
        });
      }
    });

    //100m check
    if (type === 'activity' && this.segmentType === 'RUNNING') {
      let window = [];
      samples.forEach(async (sample, index) => {
        if (sample.manual) return;

        window = samples.slice(index, samples.length - 1);
        let distance = 0;

        for (let i = 0; i < window.length - 1; i++) {
          if (window[i].manual) continue;

          distance = window[i].distance_in_meters - sample.distance_in_meters;

          if (
            distance >= 100 &&
            window[i].elapsed_time - sample.elapsed_time <= 9
          ) {
            const markerPopup = L.popup().setContent(
              `100m mark<br />lat: ${window[i + 1].lat}<br /> lng: ${
                window[i + 1].lng
              }<br />sample index: ${index + i + 1}<br />elapsed_time (100m): ${
                window[i].elapsed_time - sample.elapsed_time
              } seconds
              <br />distance (100m): ${distance} meters
              <br />time_in_seconds (start): ${sample.time_in_seconds}
              <br />time_in_seconds (100m): ${window[i].time_in_seconds}`
            );

            this.addMarker(L.latLng(sample.lat, sample.lng), {
              color: '#ff9900',
              interactive: false,
            });
            this.addMarker(
              L.latLng(window[i + 1].lat, window[i + 1].lng),
              {
                color: '#ff33ff',
                interactive: false,
              }
              // markerPopup
            );

            break; // Exit the loop after finding the first valid point
          } else if (distance >= 100) {
            break; // Exit the loop if distance exceeded but time condition not met
          } else {
            // Do nothing, continue accumulating distance.
          }
        }
      });
    }
  }

  addMarker(latLng, options, markerPopup) {
    const marker = L.circleMarker(latLng, options);
    if (markerPopup) marker.bindPopup(markerPopup);
    marker.addTo(this.map);
    return marker;
  }
}
